import type { Banner } from './banner';

/**
 * Tek doğruluk kaynağı: her placement web'de hangi en-boy oranında gösteriliyorsa
 * admin panelde de görsel o orana kırpılmak zorunda. Tailwind class string'leri
 * shared/ klasörü Tailwind content taramasına dahil olmadığı için burada DEĞİL,
 * her projede (admin_panel, web) literal olarak yazılmalı — buradan sadece
 * sayısal oran tüketilir.
 */
export const BANNER_ASPECT_RATIO: Record<NonNullable<Banner['placement']>, number> = {
    hero: 21 / 9,
    featured: 4 / 3,
    small: 1,
};

export function getEffectivePlacement(
    banner: Pick<Banner, 'placement' | 'gridSize'>
): NonNullable<Banner['placement']> {
    if (banner.placement) return banner.placement;
    return banner.gridSize === 'large' ? 'featured' : 'small';
}
